import React, {
  createContext,
  useState,
  useEffect,
  useReducer,
  useRef,
} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [apiUrl] = useState(process.env.REACT_APP_API_URL);
  axios.defaults.withCredentials = true;
  const [email, setEmail] = useState("");

  const [user, setUser] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // <-- NEW

  const [storage, setStorage] = useState(null);

  const [showQuestion, setShowQuestion] = useState(true);

  const [userQuestion1, setUserQuestion1] = useState([]);
  const [userQuestion2, setUserQuestion2] = useState([]);
  const [userQuestion3, setUserQuestion3] = useState([]);
  const [userQuestion4, setUserQuestion4] = useState([]);
  const [userQuestion5, setUserQuestion5] = useState([]);

  const [googleUserQuestion1, setGoogleUserQuestion1] = useState([]);
  const [googleUserQuestion2, setGoogleUserQuestion2] = useState([]);
  const [googleUserQuestion3, setGoogleUserQuestion3] = useState([]);
  const [googleUserQuestion4, setGoogleUserQuestion4] = useState([]);
  const [googleUserQuestion5, setGoogleUserQuestion5] = useState([]);

  const [userQuestion2_1, setUserQuestion2_1] = useState([]);
  const [userQuestion2_2, setUserQuestion2_2] = useState([]);
  const [userQuestion2_3, setUserQuestion2_3] = useState([]);
  const [userQuestion2_4, setUserQuestion2_4] = useState([]);
  const [userQuestion2_5, setUserQuestion2_5] = useState([]);

  const [googleUserQuestion2_1, setGoogleUserQuestion2_1] = useState([]);
  const [googleUserQuestion2_2, setGoogleUserQuestion2_2] = useState([]);
  const [googleUserQuestion2_3, setGoogleUserQuestion2_3] = useState([]);
  const [googleUserQuestion2_4, setGoogleUserQuestion2_4] = useState([]);
  const [googleUserQuestion2_5, setGoogleUserQuestion2_5] = useState([]);

  const [userQuestion3_1, setUserQuestion3_1] = useState([]);
  const [userQuestion3_2, setUserQuestion3_2] = useState([]);
  const [userQuestion3_3, setUserQuestion3_3] = useState([]);
  const [userQuestion3_4, setUserQuestion3_4] = useState([]);
  const [userQuestion3_5, setUserQuestion3_5] = useState([]);

  const [googleUserQuestion3_1, setGoogleUserQuestion3_1] = useState([]);
  const [googleUserQuestion3_2, setGoogleUserQuestion3_2] = useState([]);
  const [googleUserQuestion3_3, setGoogleUserQuestion3_3] = useState([]);
  const [googleUserQuestion3_4, setGoogleUserQuestion3_4] = useState([]);
  const [googleUserQuestion3_5, setGoogleUserQuestion3_5] = useState([]);

  const [userQuestion4_1, setUserQuestion4_1] = useState([]);
  const [userQuestion4_2, setUserQuestion4_2] = useState([]);
  const [userQuestion4_3, setUserQuestion4_3] = useState([]);
  const [userQuestion4_4, setUserQuestion4_4] = useState([]);
  const [userQuestion4_5, setUserQuestion4_5] = useState([]);

  const [googleUserQuestion4_1, setGoogleUserQuestion4_1] = useState([]);
  const [googleUserQuestion4_2, setGoogleUserQuestion4_2] = useState([]);
  const [googleUserQuestion4_3, setGoogleUserQuestion4_3] = useState([]);
  const [googleUserQuestion4_4, setGoogleUserQuestion4_4] = useState([]);
  const [googleUserQuestion4_5, setGoogleUserQuestion4_5] = useState([]);

  const [userQuestion5_1, setUserQuestion5_1] = useState([]);
  const [userQuestion5_2, setUserQuestion5_2] = useState([]);
  const [userQuestion5_3, setUserQuestion5_3] = useState([]);
  const [userQuestion5_4, setUserQuestion5_4] = useState([]);
  const [userQuestion5_5, setUserQuestion5_5] = useState([]);

  const [googleUserQuestion5_1, setGoogleUserQuestion5_1] = useState([]);
  const [googleUserQuestion5_2, setGoogleUserQuestion5_2] = useState([]);
  const [googleUserQuestion5_3, setGoogleUserQuestion5_3] = useState([]);
  const [googleUserQuestion5_4, setGoogleUserQuestion5_4] = useState([]);
  const [googleUserQuestion5_5, setGoogleUserQuestion5_5] = useState([]);

  const [userQuestion6_1, setUserQuestion6_1] = useState([]);
  const [userQuestion6_2, setUserQuestion6_2] = useState([]);
  const [userQuestion6_3, setUserQuestion6_3] = useState([]);
  const [userQuestion6_4, setUserQuestion6_4] = useState([]);
  const [userQuestion6_5, setUserQuestion6_5] = useState([]);

  const [googleUserQuestion6_1, setGoogleUserQuestion6_1] = useState([]);
  const [googleUserQuestion6_2, setGoogleUserQuestion6_2] = useState([]);
  const [googleUserQuestion6_3, setGoogleUserQuestion6_3] = useState([]);
  const [googleUserQuestion6_4, setGoogleUserQuestion6_4] = useState([]);
  const [googleUserQuestion6_5, setGoogleUserQuestion6_5] = useState([]);

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [payload, setPayload] = useState(null);

  const [bgColor, setBgColor] = useState("");

  const [status, setStatus] = useState("");

  const [paymentLocation, setPaymetLocation] = useState("");

  const [sessionId, setSessionId] = useState(null);

  const [payed, setPayed] = useState(null);

  const [slug, setSlug] = useState(null);

  const [prevLocation, setPrevLocation] = useState(null);

  const [userProgress, setUserProgress] = useState(null);

  const videoRef1 = useRef();

  const [vidDuration, setVidDuration] = useState(null);
  const [vidCurrTime, setVidCurrTime] = useState(0);

  const [googleUser, setGoogleUser] = useState(null);

  const [redirection, setRedirection] = useState(null);

  const [userAnswer, setUserAnswer] = useState(null);

  const [googleUserAnswer, setGoogleUserAnswer] = useState(null);

  const navigate = useNavigate();

  const [phase1Complete, setPhase1Complete] = useState(false);
  const [phase2Complete, setPhase2Complete] = useState(false);
  const [phase3Complete, setPhase3Complete] = useState(false);
  const [phase4Complete, setPhase4Complete] = useState(false);
  const [phase5Complete, setPhase5Complete] = useState(false);

  const [precentCompletion, setPrecentCompletion] = useState(0);

  const [themeCompletion, setThemeCompletion] = useState(null);
  const [themeCompletion1, setThemeCompletion1] = useState(null);

  const [error, setError] = useState("");

  const [payedStressFatigue, setPayedStressFatigue] = useState(null);

  const [themePayed, setThemePayed] = useState({});

  // ✅ Put this inside AuthProvider (replace your restoreAuth + first useEffect)

  const restoreAuth = async () => {
    try {
      const googleUserRes = await axios.get(`${apiUrl}/api/auth/user-info`, {
        withCredentials: true,
      });

      if (googleUserRes.data?.authenticated) {
        setGoogleUser(googleUserRes.data);
        setUser(null);
        setAuthenticated(true);
        return;
      }

      const emailUserRes = await axios.get(
        `${apiUrl}/api/auth/user-email-info`,
        { withCredentials: true },
      );

      if (emailUserRes.data?.authenticated) {
        setUser(emailUserRes.data);
        setGoogleUser(null);
        setAuthenticated(true);
        return;
      }

      setUser(null);
      setGoogleUser(null);
      setAuthenticated(false);
    } catch (err) {
      setUser(null);
      setGoogleUser(null);
      setAuthenticated(false);
    }
  };

  useEffect(() => {
    let mounted = true;

    (async () => {
      setLoading(true);
      await restoreAuth();
      if (mounted) setLoading(false);
    })();

    return () => {
      mounted = false;
    };
  }, [apiUrl]); // ✅ include apiUrl so it doesn't capture stale env

  useEffect(() => {
    async function addAnswers() {
      const firstAnswer = JSON.parse(
        localStorage.getItem("first_answer") || "null",
      );
      const secondAnswer = JSON.parse(
        localStorage.getItem("second_answer") || "null",
      );

      const firstAnswerProgess = JSON.parse(
        localStorage.getItem("first_answer_progress") || "null",
      );
      const secondAnswerProgress = JSON.parse(
        localStorage.getItem("second_answer_progress") || "null",
      );
      if (user || googleUser) {
        if (
          firstAnswer &&
          secondAnswer &&
          firstAnswerProgess &&
          secondAnswerProgress
        ) {
          const answerData = {
            questionId: firstAnswer.questionId,
            answerLabel: firstAnswer.answerLabel,
            phaseId: firstAnswer.phaseId,
            reflectionVideoUrl: firstAnswer.reflectionVideoUrl,
            themeSlug: firstAnswer.themeSlug,
            ...(user ? { userUsername: user.username } : {}),
            ...(googleUser ? { googleEmail: googleUser.email } : {}),
          };
          const answerData1 = {
            questionId: secondAnswer.questionId,
            answerLabel: secondAnswer.answerLabel,
            phaseId: secondAnswer.phaseId,
            reflectionVideoUrl: secondAnswer.reflectionVideoUrl,
            themeSlug: secondAnswer.themeSlug,
            ...(user ? { userUsername: user.username } : {}),
            ...(googleUser ? { googleEmail: googleUser.email } : {}),
          };

          const firstAnswerProgressData = {
            themeSlug: firstAnswerProgess.themeSlug,
            phaseName: firstAnswerProgess.phaseTitle,
            uuid: firstAnswerProgess.hashed,
            answerTitle: firstAnswerProgess.answerLabel,
            ...(user ? { username: user.username } : {}),
            ...(googleUser ? { googleEmail: googleUser.email } : {}),
          };

          const secondAnswerProgressData = {
            themeSlug: secondAnswerProgress.themeSlug,
            phaseName: secondAnswerProgress.phaseTitle,
            uuid: secondAnswerProgress.hashed,
            answerTitle: secondAnswerProgress.answerLabel,
            ...(user ? { username: user.username } : {}),
            ...(googleUser ? { googleEmail: googleUser.email } : {}),
          };
          try {
            await axios.post(`${apiUrl}/user-question/add`, answerData);

            await axios.post(`${apiUrl}/user-question/add`, answerData1);

            await axios.post(
              `${apiUrl}/user-progress/add`,
              firstAnswerProgressData,
            );

            await axios.post(
              `${apiUrl}/user-progress/add`,
              secondAnswerProgressData,
            );

            localStorage.removeItem("first_answer");
            localStorage.removeItem("second_answer");

            localStorage.removeItem("first_answer_progress");
            localStorage.removeItem("second_answer_progress");
          } catch (error) {
            console.error("Failed to submit answer:", error);
          }
        }
      }
    }

    addAnswers();
  }, [user, googleUser]);

  useEffect(() => {
    if (!loading && (googleUser || user)) {
      const redirect = localStorage.getItem("postLoginRedirect");

      if (redirect && redirect !== "/login" && redirect !== "/signup") {
        localStorage.removeItem("postLoginRedirect");
        navigate(redirect, { replace: true });
      }
    }
  }, [loading, googleUser, user, navigate]);

  async function userLogout() {
    try {
      await axios.get(apiUrl + "/api/auth/logout", {
        withCredentials: true,
      });

      localStorage.removeItem("userCookie");

      setUser(null);
      setGoogleUser(null); // ✅ clear both
      setAuthenticated(false);

      // ✅ no need setLoading(true) then full reload
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed:", err);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        themePayed,
        setThemePayed,
        payedStressFatigue,
        setPayedStressFatigue,
        error,
        setError,
        apiUrl,
        themeCompletion1,
        setThemeCompletion1,
        themeCompletion,
        setThemeCompletion,
        precentCompletion,
        setPrecentCompletion,
        phase1Complete,
        setPhase1Complete,
        phase2Complete,
        setPhase2Complete,
        phase3Complete,
        setPhase3Complete,
        phase4Complete,
        setPhase4Complete,
        phase5Complete,
        setPhase5Complete,
        userAnswer,
        setUserAnswer,
        googleUserAnswer,
        setGoogleUserAnswer,
        redirection,
        setRedirection,
        googleUser,
        setGoogleUser,
        // resumeLastProgress,
        googleUserQuestion1,
        googleUserQuestion2,
        googleUserQuestion3,
        googleUserQuestion4,
        googleUserQuestion5,
        setGoogleUserQuestion1,
        setGoogleUserQuestion2,
        setGoogleUserQuestion3,
        setGoogleUserQuestion4,
        setGoogleUserQuestion5,

        userQuestion2_1,
        userQuestion2_2,
        userQuestion2_3,
        userQuestion2_4,
        userQuestion2_5,
        setUserQuestion2_1,
        setUserQuestion2_2,
        setUserQuestion2_3,
        setUserQuestion2_4,
        setUserQuestion2_5,
        googleUserQuestion2_1,
        googleUserQuestion2_2,
        googleUserQuestion2_3,
        googleUserQuestion2_4,
        googleUserQuestion2_5,
        setGoogleUserQuestion2_1,
        setGoogleUserQuestion2_2,
        setGoogleUserQuestion2_3,
        setGoogleUserQuestion2_4,
        setGoogleUserQuestion2_5,

        userQuestion3_1,
        userQuestion3_2,
        userQuestion3_3,
        userQuestion3_4,
        userQuestion3_5,
        setUserQuestion3_1,
        setUserQuestion3_2,
        setUserQuestion3_3,
        setUserQuestion3_4,
        setUserQuestion3_5,
        googleUserQuestion3_1,
        googleUserQuestion3_2,
        googleUserQuestion3_3,
        googleUserQuestion3_4,
        googleUserQuestion3_5,
        setGoogleUserQuestion3_1,
        setGoogleUserQuestion3_2,
        setGoogleUserQuestion3_3,
        setGoogleUserQuestion3_4,
        setGoogleUserQuestion3_5,

        userQuestion4_1,
        userQuestion4_2,
        userQuestion4_3,
        userQuestion4_4,
        userQuestion4_5,
        setUserQuestion4_1,
        setUserQuestion4_2,
        setUserQuestion4_3,
        setUserQuestion4_4,
        setUserQuestion4_5,
        googleUserQuestion4_1,
        googleUserQuestion4_2,
        googleUserQuestion4_3,
        googleUserQuestion4_4,
        googleUserQuestion4_5,
        setGoogleUserQuestion4_1,
        setGoogleUserQuestion4_2,
        setGoogleUserQuestion4_3,
        setGoogleUserQuestion4_4,
        setGoogleUserQuestion4_5,

        userQuestion5_1,
        userQuestion5_2,
        userQuestion5_3,
        userQuestion5_4,
        userQuestion5_5,
        setUserQuestion5_1,
        setUserQuestion5_2,
        setUserQuestion5_3,
        setUserQuestion5_4,
        setUserQuestion5_5,
        googleUserQuestion5_1,
        googleUserQuestion5_2,
        googleUserQuestion5_3,
        googleUserQuestion5_4,
        googleUserQuestion5_5,
        setGoogleUserQuestion5_1,
        setGoogleUserQuestion5_2,
        setGoogleUserQuestion5_3,
        setGoogleUserQuestion5_4,
        setGoogleUserQuestion5_5,

        userQuestion6_1,
        userQuestion6_2,
        userQuestion6_3,
        userQuestion6_4,
        userQuestion6_5,
        setUserQuestion6_1,
        setUserQuestion6_2,
        setUserQuestion6_3,
        setUserQuestion6_4,
        setUserQuestion6_5,
        googleUserQuestion6_1,
        googleUserQuestion6_2,
        googleUserQuestion6_3,
        googleUserQuestion6_4,
        googleUserQuestion6_5,
        setGoogleUserQuestion6_1,
        setGoogleUserQuestion6_2,
        setGoogleUserQuestion6_3,
        setGoogleUserQuestion6_4,
        setGoogleUserQuestion6_5,

        storage,
        setStorage,
        userLogout,
        user,
        authenticated,
        loading,
        email,
        setLoading,
        setEmail,
        setUser,
        setAuthenticated,
        refreshTrigger,
        setRefreshTrigger,
        userQuestion1,
        userQuestion2,
        userQuestion3,
        userQuestion4,
        userQuestion5,
        setUserQuestion1,
        setUserQuestion2,
        setUserQuestion3,
        setUserQuestion4,
        setUserQuestion5,
        showQuestion,
        setShowQuestion,
        bgColor,
        setBgColor,
        status,
        setStatus,
        paymentLocation,
        setPaymetLocation,
        payload,
        setPayload,
        sessionId,
        setSessionId,
        payed,
        setPayed,
        slug,
        setSlug,
        prevLocation,
        setPrevLocation,
        userProgress,
        setUserProgress,
        videoRef1,
        vidDuration,
        vidCurrTime,
        setVidCurrTime,
        setVidDuration,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
